import { parse, format } from "date-fns";
import { useSetAtom } from "jotai";
import { useCallback } from "react";

import { RequestAvailableCard } from "@whoosh/design-system/src/apps/PatronApp/screens/multiSlotBooking/components/RequestAvailableCard/RequestAvailableCard";

import { multiSlotRequestBookingInfoAtom } from "../../../atoms";

type RequestRestrictionSlotProps = {
  startTime: string;
  durationMins: number;
  queueSlotId: string;
};

export const RequestRestrictionSlot = ({
  startTime,
  durationMins,
  queueSlotId,
}: RequestRestrictionSlotProps) => {
  const startTimeObj = parse(startTime, "HH:mm:ss", new Date());
  const formattedTimeSelectorTime = format(startTimeObj, "HH:mm:ss");
  const setMultiSlotRequestBookingInfo = useSetAtom(
    multiSlotRequestBookingInfoAtom
  );

  const handlePress = useCallback(() => {
    setMultiSlotRequestBookingInfo({
      queueSlotId,
      requestedTime: formattedTimeSelectorTime,
    });
  }, [queueSlotId, formattedTimeSelectorTime, setMultiSlotRequestBookingInfo]);

  return (
    <RequestAvailableCard durationMins={durationMins} onPress={handlePress} />
  );
};
